import * as Yup from 'yup';
import i18n from 'config/i18n';
import { IpRangeFormat, IpVersion } from '../modules/app/types';
import { ipv4CidrRegex, ipv4RangeRegex, ipv4Regex, ipv6CidrRegex, ipv6RangeRegex, ipv6Regex } from '.';

export const ipAddressessSchema = Yup.string()
  .required(() => i18n.t('validation:required'))
  .when('format', {
    is: IpRangeFormat.Range,
    then: Yup.string()
      .required(() => i18n.t('validation:required'))
      .when('ipVersion', {
        is: IpVersion.Ipv4,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv4RangeRegex, () => i18n.t('validation:ipRegexNoMatch')),
      })
      .when('ipVersion', {
        is: IpVersion.Ipv6,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv6RangeRegex, () => i18n.t('validation:ipRegexNoMatch')),
      }),
  })
  .when('format', {
    is: IpRangeFormat.Single,
    then: Yup.string()
      .required(() => i18n.t('validation:required'))
      .when('ipVersion', {
        is: IpVersion.Ipv4,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv4Regex, () => i18n.t('validation:ipRegexNoMatch')),
      })
      .when('ipVersion', {
        is: IpVersion.Ipv6,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv6Regex, () => i18n.t('validation:ipRegexNoMatch')),
      }),
  })
  .when('format', {
    is: IpRangeFormat.Cidr,
    then: Yup.string()
      .required(() => i18n.t('validation:required'))
      .when('ipVersion', {
        is: IpVersion.Ipv4,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv4CidrRegex, () => i18n.t('validation:ipRegexNoMatch')),
      })
      .when('ipVersion', {
        is: IpVersion.Ipv6,
        then: Yup.string()
          .required(() => i18n.t('validation:required'))
          .matches(ipv6CidrRegex, () => i18n.t('validation:ipRegexNoMatch')),
      }),
  });

export const ipValidationSchema = Yup.object().shape({
  ipRanges: Yup.array().of(
    Yup.object().shape({
      description: Yup.string().required(() => i18n.t('validation:required')),
      format: Yup.mixed()
        .required(() => i18n.t('validation:required'))
        .oneOf([...Object.values(IpRangeFormat)], ({ values }) => i18n.t('validation:oneOf', { values })),
      ipAddresses: ipAddressessSchema,
      ipVersion: Yup.mixed()
        .oneOf([IpVersion.Ipv4, IpVersion.Ipv6], ({ values }) => i18n.t('validation:oneOf', { values }))
        .required(() => i18n.t('validation:required'))
        .nullable(),
    })
  ),
});
